import { render, staticRenderFns } from "./YearGoalsChart.vue?vue&type=template&id=0135e3a9"
import script from "./YearGoalsChart.vue?vue&type=script&lang=js"
export * from "./YearGoalsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0135e3a9')) {
      api.createRecord('0135e3a9', component.options)
    } else {
      api.reload('0135e3a9', component.options)
    }
    module.hot.accept("./YearGoalsChart.vue?vue&type=template&id=0135e3a9", function () {
      api.rerender('0135e3a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/year-goals-chart/YearGoalsChart.vue"
export default component.exports